import NotificationsPage from "./ui/NotificationsPage.vue";
export default NotificationsPage;
